<template>
  <div class="h-100">
    <map-side-bar :is-open="sidebarOpen">
      <template #title>{{currentSidebarTitle}}</template>
      <template #default>
        <component :is="currentSidebar"></component>
      </template>
    </map-side-bar>

    <div class="play" v-if="points">
      <feather-icon icon="ChevronsLeftIcon" @click="decreaseSpeed" size="30"/>
      <feather-icon v-if="isPlaying" @click="pause" icon='PauseIcon' size="30"/>
      <feather-icon v-else @click="move" icon="PlayIcon" size="30"/>
      {{ defaultSpeed }}
      <feather-icon @click="increaseSpeed" icon="ChevronsRightIcon" size="30"/>
    </div>

    <div :class="'tables-options'">
      <div class="tab-click">
        <b-button class="icon-wrapper" v-on:click="resetDirection(),$router.push('/')" v-b-tooltip.hover.left="$t('dashboard')">
          <feather-icon icon="HomeIcon" size="10"/>
        </b-button>
        <div class="icon-wrapper" :class="{'option-active':currentSidebar === 'h-form' }"
            v-b-tooltip.hover.left="$t('get history')"
             @click="$store.dispatch('h_map_store/toggle_sidebar',
             {component: 'h-form', title: $t('Get History')})">
          <feather-icon icon="ClockIcon" size="10"/>
        </div>
        <div class="icon-wrapper" :class="{'option-active':currentSidebar === 'map-geo-side-bar' }"
            v-b-tooltip.hover.left="$t('geofences')"
             @click="$store.dispatch('h_map_store/toggle_sidebar',
             {component: 'map-geo-side-bar', title: $t('geofences')})">
          <feather-icon icon="GlobeIcon" size="10"/>
        </div>
      </div>
    </div>

    <div dir="ltr">
      <l-map ref="mapRef" style="height: 100%; width: 100%"
             :zoom="zoom" :center="center">
        <l-tile-layer :url="url"></l-tile-layer>
      </l-map>
    </div>

  </div>
</template>

<script>

import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet"
import 'leaflet/dist/leaflet.css'
import { computed, onMounted, onUnmounted, ref, watch } from '@vue/composition-api'
import { OrbitSpinner } from 'epic-spinners'
import { BButton, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import HForm from '@/views/maps/history/HForm'
import store from '@/store'
import historyState from '@/app/maps/history/history.state'
import Route from '@/app/maps/utils/route/route'
import Player from '@/app/maps/utils/videoPlayer/player'
import MapSideBar from '@/components/sidebar/MapSideBar'
import mapDrawGeofences from '@/views/modules/maps/mapDrawGeofences'

import useMap from "@/views/modules/maps/uses/useMap";
export default {
  name: 'HistoryMap',
  directives: { 'b-tooltip': VBTooltip, Ripple},
  components: {
    LMap, LTileLayer, LMarker, LPopup,HForm, LTooltip,
    OrbitSpinner, BButton, MapSideBar
  },

  setup() {

    let storeDirection = store.state.auth.userData.settings.lang === 'ar' ? 'rtl' : 'ltr'
    const resetDirection= () => {
      document.getElementsByTagName('html')[0].dir = storeDirection;
      //document.getElementsByTagName('body')[0].dir = storeDirection;
      }
    document.getElementsByTagName('html')[0].dir = "ltr"
   // const map = ref(null)
    const mapRef = ref(null)
    const { init_layers ,map } = useMap()
    onMounted(() => {
      
      map.value = mapRef.value.mapObject
      init_layers()
     
    })

    const H_MAP_STORE = 'h_map_store'
    if (!store.hasModule(H_MAP_STORE))
      store.registerModule(H_MAP_STORE, historyState)

    onUnmounted(() => {
      if (store.hasModule(H_MAP_STORE)) {
        store.commit('h_map_store/INIT_STORE')
        store.unregisterModule(H_MAP_STORE)
      }
    })

    const sidebarOpen = computed(() => store.state.h_map_store.sidebarOpen)
    const currentSidebar = computed(() => store.state.h_map_store.currentSidebar)
    const currentSidebarTitle = computed(() => store.state.h_map_store.currentSidebarTitle)
    const points = computed(() => store.state.h_map_store.historyData)
    const loading = computed(() => store.state.h_map_store.loading)

    const geofences = computed(() => store.state.h_map_store.geofences)

    const { drawArea, removeAllGeos, geofenceVisibility } = mapDrawGeofences(map)

    watch(geofences, data => {
      removeAllGeos()
      data.map(g => drawArea(g))
    })

    const { drawLine, marker, clearRoute } = Route()
    const {move, pause, increaseSpeed, decreaseSpeed, defaultSpeed, isPlaying} = Player(points, marker, map)

    watch(points, data => {
      clearRoute()
      drawLine(data, map.value)
    })



    const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    const zoom = 8
    const center = [24.7136, 46.6753]


    return {
      currentSidebar,
      move, increaseSpeed, decreaseSpeed, pause,
      isPlaying, defaultSpeed,
      currentSidebarTitle,
      points,
      loading,
      sidebarOpen,
      url,
      zoom,
      center,
      init_layers,
      mapRef,resetDirection
    }

  }
}
</script>

<style lang="less" >
@import 'liveStyles.less';

.tables-options{
  display:  block ruby;;
}
</style>
